import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from "react";
import Box from "@mui/material/Box";
import { DebugColor, DebugPopover, DebugType, useShowDebugLayout, } from "@plansoft-configuration-renderer/debug";
export function ReactPageLayoutDebug({ layout, children, }) {
    const showDebug = useShowDebugLayout();
    if (!showDebug) {
        return _jsx(Fragment, { children: children });
    }
    return (_jsxs(Box, { sx: {
            p: 0.1,
            border: 3,
            borderColor: "Layout.light",
            backgroundColor: "Layout.light",
        }, children: [_jsx(DebugPopover, { src: layout, title: `Layout ${layout.id}`, id: layout.id, type: DebugType.Layout, color: DebugColor.Layout }), _jsx(_Fragment, { children: children })] }));
}
//# sourceMappingURL=ReactPageLayoutDebug.js.map